import React from 'react'
import CraftIdentityHint from './CraftIdentityHint';
import useProfile from 'hooks/useProfile';

const CraftIdentityHintCheck = () => {

  const {flags} = useProfile();
  const {has_identity_crafting_demo} = flags;

  if (has_identity_crafting_demo) {
    return (
      <CraftIdentityHint />
    )
  } else return null;
}

export default CraftIdentityHintCheck;
